<template>
  <div style="margin: 0 5%">
    <h1 style="font-weight: bold">预约凭证</h1>
    <!--    <vue-qr align="center" :logoSrc="imagePath" :text="text" :size="200" :margin="0"></vue-qr>-->
    <a-descriptions
      bordered
      :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      size="small"
      align="left"
      :style="{background:'url('+imagePath+')'}"
    >
      <a-descriptions-item label="申请人姓名">
        {{ this.$route.query.fcreater }}
      </a-descriptions-item>
      <a-descriptions-item label="预约类型">
        {{ ftrantype.ftrantname }}
      </a-descriptions-item>
      <a-descriptions-item label="到访日期">
        {{ arrivedate() }}
      </a-descriptions-item>
      <a-descriptions-item label="离开日期">
        {{ leavedate() }}
      </a-descriptions-item>
      <a-descriptions-item label="到访人姓名">
        {{ this.$route.query.fname }}
      </a-descriptions-item>
      <a-descriptions-item label="到访人电话">
        {{ this.$route.query.fphone }}
      </a-descriptions-item>
      <a-descriptions-item label="车牌号">
        {{ this.$route.query.flicenseplate }}
      </a-descriptions-item>
      <a-descriptions-item label="到访事项">
        {{ this.$route.query.faffair }}
      </a-descriptions-item>
      <a-descriptions-item label="是否带货出门">
        {{ this.$route.query.fgoodsout == 1 ? '是' : '否' }}
      </a-descriptions-item>
      <a-descriptions-item label="公司地址">
        {{ this.$route.query.flocation == 1 ? '太仓港经济技术开发区元江路88号' : '上海市嘉定区蕴北公路1755弄9号楼1-4' }}
      </a-descriptions-item>
    </a-descriptions>
    <br/>
    <a-button type="primary" @click="inDoor()">
      进场
    </a-button>&nbsp;&nbsp;&nbsp;&nbsp;
    <a-button type="danger" @click="outDoor()">
      出场
    </a-button>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import axios from "axios";

export default {
  name: "qrcodeCheck",
  components: {VueQr},
  data() {
    return {
      // text: "http://www.tcnanhua.com:5555/ui/qrcodeCheck?fname=" + encodeURIComponent(this.$route.query.fname) +
      //   "&fphone=" + this.$route.query.fphone +
      //   "&fcontract=" + encodeURIComponent(this.$route.query.fcontract) +
      //   "&fcontractphone=" + this.$route.query.fcontractphone +
      //   "&flicenseplate=" + encodeURIComponent(this.$route.query.flicenseplate) +
      //   "&fdate=" + this.$route.query.fdate +
      //   "&fchecker=" + encodeURIComponent(this.$route.query.fchecker) +
      //   "&faffair=" + encodeURIComponent(this.$route.query.faffair),
      // imagePath: require('../assets/nh.png'),//中间logo的地址
      imagePath: require('../assets/bj7.jpg'),
      ftrantype: '',
    }
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/t-nh-appointmenttype/selectTNhAppointmenttypeByFtrantype?ftrantype=" + this.$route.query.ftrantype)
      .then((res) => {
        this.ftrantype = res.data.data;
      })
  },
  computed: {
    // formDate: function () {
    //   let dateUtil = new Date(this.$route.query.fdate / 1);
    //   let month = dateUtil.getMonth() + 1;
    //   return dateUtil.getFullYear() + "年" + month + "月" + dateUtil.getDate() + "日  " + dateUtil.getHours() + ":" + dateUtil.getMinutes() + ":" + dateUtil.getSeconds();
    // },
  },
  methods: {
    arrivedate() {
      let date = new Date(this.$route.query.farrivetime / 1);
      let month = date.getMonth() + 1;
      return date.getFullYear() + "年" + month + "月" + date.getDate() + "日  " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    leavedate() {
      let date = new Date(this.$route.query.fleavetime / 1);
      let month = date.getMonth() + 1;
      return date.getFullYear() + "年" + month + "月" + date.getDate() + "日  " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    inDoor() {
      this.$message.loading('提交中...');
      axios.get("http://www.tcnanhua.com:5555/t-nh-appointment/inDoor?fcreater=" + this.$route.query.fcreater + "&ftrantype=" + this.$route.query.ftrantype
        + "&farrivetime=" + this.$route.query.farrivetime + "&fleavetime=" + this.$route.query.fleavetime + "&fname=" + this.$route.query.fname + "&fphone=" + this.$route.query.fphone
        + "&faffair=" + this.$route.query.faffair + "&fgoodsout=" + this.$route.query.fgoodsout + "&fchecker=" + this.$route.query.fchecker)
        .then(() => {
          this.$message.success('已进场,页面即将关闭,若未关闭请手动关闭');
        });
      setTimeout(function () {
        window.opener = null;
        window.open("about:blank", "_top").close();
      }, 3000);
    },
    outDoor() {
      this.$message.loading('提交中...');
      axios.get("http://www.tcnanhua.com:5555/t-nh-appointment/outDoor?fcreater=" + this.$route.query.fcreater + "&ftrantype=" + this.$route.query.ftrantype
        + "&farrivetime=" + this.$route.query.farrivetime + "&fleavetime=" + this.$route.query.fleavetime + "&fname=" + this.$route.query.fname + "&fphone=" + this.$route.query.fphone
        + "&faffair=" + this.$route.query.faffair + "&fgoodsout=" + this.$route.query.fgoodsout + "&fchecker=" + this.$route.query.fchecker)
        .then(() => {
          this.$message.success('已出场,页面即将关闭,若未关闭请手动关闭');
        });
      setTimeout(function () {
        window.opener = null;
        window.open("about:blank", "_top").close();
      }, 3000);
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QRcodeCheck.vue